var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mx-auto px-0"},[_c('Forms',{attrs:{"defaultValue":_vm.defaultValue,"items":_vm.items,"type":_vm.type,"loading":_vm.loading,"errors":_vm.errors,"hideGoToDetailsButton":""},on:{"submit":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }